import(/* webpackMode: "eager", webpackExports: ["PostHogIdentifier"] */ "/vercel/path0/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppSidebar"] */ "/vercel/path0/components/app-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardTrigger"] */ "/vercel/path0/components/dashboard-trigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DynamicBreadcrumbs"] */ "/vercel/path0/components/dynamic-breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/route-transition-frame.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider","SidebarInset"] */ "/vercel/path0/components/tailwind/ui/sidebar.tsx");
